import React from "react";

import classNames from "classnames";

type Props = { size?: number; className?: string; style?: React.CSSProperties };

const sizeClasses: Record<number, string> = {
  3: "h-3 w-3",
  4: "h-4 w-4",
  5: "h-5 w-5",
  6: "h-6 w-6",
  8: "h-8 w-8",
  10: "h-10 w-10",
  12: "h-12 w-12",
};

export function LoadingSpinner({ size = 6, className, style }: Props) {
  return (
    <svg
      style={style}
      className={classNames(
        sizeClasses[size] ?? sizeClasses[6],
        "animate-spin",
        className,
      )}
      role="status"
      aria-label="Loading"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
